import { NgClass } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Subscription } from 'rxjs';
import { GlobalService } from 'shared/core/services/global.service';

@Component({
    selector: 'dashboard-popup-alert',
    templateUrl: './dashboard-popup-alert.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dashboard-popup-alert.component.scss'],
    imports: [NgClass, MatButton],
})
export class DashboardPopupAlertComponent implements AfterViewInit, OnDestroy {
    show = false;
    title: string = '';
    textIsArray: boolean = false;
    text: string | string[] = '';
    lock = false;
    private subscription: Subscription;
    constructor(private globalService: GlobalService) {
        this.subscription = globalService.alertObservable.subscribe(data => {
            if (!data) {
                this.show = false;
                return;
            }
            this.show = true;
            this.title = data.title;
            this.textIsArray = Array.isArray(data.text);
            this.text = data.text;
        });
    }

    // NOTE: dismissing the "Session expired" alert used to navigate to /logout.
    // That was wrong for an *involuntary* expiry: LogoutPage calls access/logout
    // and then redirects the whole browser to the IdP's logout endpoint
    // (login.microsoftonline.com/.../oauth2/v2.0/logout for LHG,
    // signon.radissonhotels.com/adfs/ls for RHG), which tears down the user's
    // SSO session. Silent re-auth then becomes impossible and the user has to
    // retype their email, pick an account and pick a workspace.
    // ServerService.forceReLogin() has already cleared local session state and
    // navigated to /login?reason=session-expired, so the alert only needs to
    // dismiss itself and let the IdP session survive.
    public ngAfterViewInit(): void {
        $('.alert-box-inner').click(() => {
            this.lock = true;
        });
        $('#alert').click(() => {
            if (!this.lock) {
                this.globalService.alertSubj.next(null);
            }
            this.lock = false;
        });
    }
    public close(): void {
        this.globalService.alertSubj.next(null);
    }
    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
